import React from 'react';
import styles from './descriptor.module.scss';
import { split } from '../../utils/library';

interface DescriptorProps {
	value: string
}

export default function Descriptor({value}:DescriptorProps) {
	return (
		<div className={styles.default}>{split(value)}</div>
	);
}